<template>
    <div class="container">
        <div class="header">
            <img src="../../assets/image/logo.png">
            <div></div>
            <div class="header_r">
                <div>
                    <ul>
                        <li v-for="(item,index) in navList" :key="index" :class="item.active?'active':''" @click="changeNav(index,item.routerPath)">
                            <div v-if="item.routerPath != '#'" class="title">{{ item.title }}</div>
                            <div v-else class="title yd">
                                <span :class="isSelectSubMenu?'sub_active':''">{{ item.title }}</span>
                                <div class="menu">
                                    <div class="menu_item" ref="menuItem" v-for="(item2,index2) in menuList" :key="index2" :class="item2.active?'active2':''" @click="changeMenu(item2.brand_id)">
                                        <div class="text">{{ item2.title }}</div>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="btn" @click="showMask = true">
                    添加微信
                </div>
            </div>
        </div>
        <div class="mask" v-if="showMask">
            <div class="mask_main">
                <div class="gb">
                    <img src="../../assets/image/gb.png" @click="showMask = false">
                </div>
                <div class="anpg">
                    <img src="../../assets/image/ewm.jpg" alt="">
                    <div>手机扫一扫添加微信</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            navList: [
                { title: '首页',active: true,routerPath: '/' },
                { title: '产品服务',active: false,routerPath: '/product' },
                { title: '关于我们',active: false,routerPath: '/aboutus' }
            ],
            menuList: [],
            menuHeight: '0px',
            showMask: false
        }
    },
    watch: {
        $route(n) {
            window.localStorage.setItem('routePath',n.path)
            this.defaultRoute()
        }
    },
    mounted() {
        // let func = this.debounce(this.handleScrollFun, 100)
        // window.addEventListener('scroll', func);
    },
    methods: {
        handleToLogin() {
            // window.location.href = "https://saas.manzu365.com";
        },
        handleChangeTitle(index) {
            this.navList.forEach((item,i) => {
                if(index == i) {
                    item.active = true
                }else {
                    item.active = false
                }
            })
        },
        defaultRoute() {
            let selectPath = window.localStorage.getItem('routePath')
            let isFind = false
            if(selectPath == '/newsDetail') {
                selectPath = '/news'
            }
            this.navList.forEach(item => {
                if(item.routerPath == selectPath) {
                    item.active = true
                    isFind = true
                }else {
                    item.active = false
                }
            })
            //改变菜单状态
            this.menuList.forEach(item => {
                item.active = false
            })
            if(!isFind) {
                this.menuList.forEach(item => {
                    if(item.brand_id == this.$route.query.id) {
                        item.active = true
                    }else {
                        item.active = false
                    }
                })
            }
        },
        handleScrollFun() {
            const sections = [
                { id: 'banner', index: 0 },
                { id: 'introduce', index: 1 },
                { id: 'callMe', index: 2 }
            ];
            const currentPosition = window.scrollY + 10;
            sections.forEach(section => {
                const anchorPointPosition = document.getElementById(section.id).offsetTop;
                const item = this.navList[section.index];
                if (currentPosition > anchorPointPosition) {
                    this.navList.forEach((navItem, index) => {
                        navItem.active = (index === section.index);
                    });
                }
            });
        },
        debounce(func, delay) {
            let timerId;
            return function() {
                const context = this;
                const args = arguments;
                clearTimeout(timerId);
                timerId = setTimeout(function() {
                    func.apply(context, args);
                }, delay);
            };
        },
        changeNav(i,path) {
            if(path != '#') {
                this.navList.forEach((item,index) => {
                    if(index == i) {
                        item.active = true
                    }else {
                        item.active = false
                    }
                })
                this.$router.push(path)
            }
        },
    },
    computed: {

    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
    },
}
</script>
<style scoped lang="scss">
$width: 1200px;
.active {
    position: relative;
    color: #2870FF!important;
    transition: all 0.3s ease;
    &::after {
        display: block;
        content: '';
        position: absolute;
        bottom: 5px;
        left: 50%;
        width: 100%!important;
        height: 5px;
        background: #2870FF;
        transform: translateX(-50%);
        border-radius: 2px;
    }
}
.container {
    width: 100vw;
    height: 60px;
    display: flex;
    justify-content: center;
    // position: fixed;
    position: sticky;
    top: 0;
    z-index: 999;
    background: rgba($color: #fff, $alpha: 0.6);
    .header {
        width: $width;
        height: 60px;
        margin: 0 auto;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        align-items: center;
        // padding: 0 50px;
        box-sizing: border-box;
        img {
            width: 177px;
            height: 50px;
            cursor: pointer;
        }
        &_r {
            display: flex;
            align-items: center;
            column-gap: 50px;
        }
        ul {
            display: flex;
            column-gap: 50px;
            height: 70px;
            align-items: center;
            li {
                cursor: pointer;
                font-size: 16px;
                color: #666666;
                transition: all 0.3s ease;
                -webkit-user-select: none; /* Safari */
                -moz-user-select: none; /* Firefox */
                -ms-user-select: none; /* IE 10+/Edge */
                user-select: none;
                height: 70px;
                display: flex;
                align-items: center;
                position: relative;
                &::after {
                    display: block;
                    content: '';
                    position: absolute;
                    bottom: 5px;
                    left: 50%;
                    width: 0px;
                    height: 5px;
                    background: #2870FF;
                    transform: translateX(-50%);
                    border-radius: 2px;
                    transition: all 0.3s ease;
                }
                .title {
                    height: 100%;
                    line-height: 70px;
                }
            }
            li:hover {
                color: #2870FF;
                &::after {
                    width: 100%;
                }
            }
        }
        .btn {
            width: 96px;
            height: 34px;
            background: #2870FF;
            border-radius: 4px 4px 4px 4px;
            text-align: center;
            line-height: 34px;
            color: #fff;
            font-size: 16px;
            cursor: pointer;
            transition: 0.3s ease all;
            animation: shake 0.82s cubic-bezier(.36, .07, .19, .97) both infinite;
        }
        @keyframes shake {
            0% {transform: scaleX(1);}
            10%, 20% {
                transform: scale3d(.9, .9, .9) rotate(-3deg);
            }
            30%, 50%, 70%, 90% {
                transform: scale3d(1.1, 1.1, 1.1) rotate(3deg);
            }
            40%, 60%, 80% {
                transform: scale3d(1.1, 1.1, 1.1) rotate(-3deg);
            }
            100% {
                transform: scaleX(1);
            }
        }
    }
}
.mask {
    width: 100%;
    height: 100vh;
    background: rgba($color: #000000, $alpha: 0.5);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99999999;
    display: flex;
    align-items: center;
    justify-content: center;
    &_main {
      width: 450px;
      height: 300px;
      background: #FFFFFF;
      border-radius: 20px;
      padding: 20px;
      box-sizing: border-box;
      .gb {
        width: 100%;
        display: flex;
        justify-content: flex-end;
        img {
          width: 22px;
          height: 22px;
          cursor: pointer;
        }
      }
      .anpg {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        // justify-content: center;
        align-items: center;
        row-gap: 18px;
        padding-top: 16px;
        box-sizing: border-box;
        font-size: 16px;
        img {
            width: 160px;
            height: 160px;
        }
      }
    }
}
</style>